<script module>
  export { default as layout } from '@layouts/content-page-layout.svelte'
</script>

<svelte:head>
  <title>{site_page.title}</title>
</svelte:head>

<script>
  let { site_page, content } = $props()
</script>

<h1 class="text-2xl font-bold font-serif mb-8 text-center">{site_page.title}</h1>

{#if content}
  <div class="prose">{@html content}</div>
{:else}
  <p class="prose text-gray-400 italic">This page has no content yet.</p>
{/if}
